import React, { useCallback, useEffect } from 'react'
import styled from 'styled-components'

import DecimalInput from '../../../../../../../1stlog-ui/src/components/DecimalInput'
import Field, {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import { formatDecimal } from '../../../../../../../1stlog-ui/src/components/Field/format'
import useFieldState from '../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import {
  composeValidators,
  maxValue,
  mustBeFloat,
  mustBePositive,
  required,
} from '../../../../../../../1stlog-ui/src/components/Field/Validation'
import InlineEditorInvalid from '../../../../../../../1stlog-ui/src/components/InlineEditor/InlineEditorInvalid'
import { usePrevious } from '../../../../../../../1stlog-ui/src/hooks'
import { useProductSettings } from '../../../../Products'

const Wrapper = styled.div`
  max-width: 120px;
`

type TWeightProps = {
  readonly?: boolean
}

const Weight = (props: TWeightProps): React.ReactElement => {
  const { readonly } = props

  const weightDisabled = useField('weightDisabled')
  const [weight, setWeight] = useFieldState<number>('weight')

  const {
    maxWeight = 0,
    isWeightHidden,
    isWeightOptional,
  } = useProductSettings()

  const getValidate = useCallback(
    () =>
      composeValidators(
        mustBeFloat,
        isWeightOptional ? undefined : required,
        !isWeightOptional && maxWeight > 0 ? maxValue(maxWeight) : undefined,
        isWeightOptional ? undefined : mustBePositive,
      ),
    [isWeightOptional, maxWeight],
  )

  const previousMaxWeight = usePrevious(maxWeight)
  useEffect(() => {
    if (
      previousMaxWeight !== maxWeight &&
      maxWeight > 0 &&
      weight > maxWeight
    ) {
      setWeight(maxWeight)
    }
  }, [maxWeight, weight])

  if (isWeightHidden) {
    return <></>
  }

  return (
    <>
      {readonly && (
        <div className="text-center">
          <Label>{i18n.t('weight_in_kg_brackets', 'Gewicht (in kg)')}</Label>
          <h5 className="mt-1">
            {isNaN(parseFloat(String(weight))) ? (
              <InlineEditorInvalid />
            ) : (
              <span>{formatDecimal(weight, 2)} kg</span>
            )}
          </h5>
        </div>
      )}
      <Wrapper hidden={readonly}>
        <Field
          key={`${isWeightOptional},${maxWeight}`}
          name="weight"
          label={i18n.t('weight_in_kg_brackets', 'Gewicht (in kg)')}
          disabled={weightDisabled}
          required={!isWeightOptional}
          validate={getValidate()}
        >
          <DecimalInput minimumFractionDigits={2} />
        </Field>
      </Wrapper>
    </>
  )
}

export default Weight
